import { Dropdown } from "react-bootstrap";
import classNames from "classnames";
import { ReactNode, useState } from "react";
import { useUser } from "../../../hooks/useUser";
import { UserAvatar } from "../../user/UserAvatar";
import { useLogout } from "../../../hooks/useLogout";
import styles from "./UserDropdown.module.scss";
import { UserDropdownHeader } from "./UserDropdownHeader";

interface UserDropdownProps {
    items: ReactNode;
}

export const UserDropdown: React.FC<UserDropdownProps> = ({ items }) => {
    const [open, setOpen] = useState(false);
    const user = useUser();
    const logout = useLogout();

    return (
        <Dropdown show={open} onToggle={setOpen}>
            <Dropdown.Toggle
                variant="tertiary"
                className={classNames(
                    styles.userDropdownToggle,
                    "dropdown-toggle-plain",
                )}
            >
                <UserAvatar user={user} size="md" active={open} />
            </Dropdown.Toggle>
            <Dropdown.Menu align="right">
                <UserDropdownHeader user={user} />
                {items ? (
                    <>
                        <Dropdown.Divider />
                        {items}
                    </>
                ) : null}

                <Dropdown.Divider />
                <Dropdown.Item onClick={logout} data-testid="logout-button">
                    Log out
                </Dropdown.Item>
            </Dropdown.Menu>
        </Dropdown>
    );
};
